/** System-default list identifiers — synthetic, never persisted via Lists API. */
export const SYSTEM_LIST_IDS = Object.freeze({
  MY_VENDORS: "system:my-vendors",
  BOOKMARKED: "system:bookmarked",
});

export const SYSTEM_LIST_ID_SET = new Set(Object.values(SYSTEM_LIST_IDS));

export function isSystemListId(listId) {
  return SYSTEM_LIST_ID_SET.has(String(listId || ""));
}

/** Maps synthetic FE list id to BE system_list_kind. */
export function getSystemListKind(listId) {
  const id = String(listId || "");
  if (id === SYSTEM_LIST_IDS.MY_VENDORS) return "my-vendors";
  if (id === SYSTEM_LIST_IDS.BOOKMARKED) return "bookmarked";
  return null;
}

/** Max vendor logos shown on a list card before "+N more" overflow. */
export const VENDOR_LIST_CARD_MAX_LOGOS = 5;

/** Max service badges on list card Services Summary row. */
export const VENDOR_LIST_CARD_MAX_SERVICES = 5;

/** Max characters for notes preview on list cards. */
export const VENDOR_LIST_CARD_MAX_NOTES_LENGTH = 120;

/** Within-list route — opens when a Vendor Lists card is clicked. */
export const VENDOR_LIST_DETAIL_ROUTE = "/Vendors/lists";
